<template>
  <div>
    <v-img
      v-if="url"
      class="shrink d-flex align-center fullScreenPicture"
      style="
        background-color: var(--v-primary-base);
        z-index: 500;
        position: fixed;
        top: 0;
        right: 0;
        left: 0;
        bottom: 0;
      "
      :src="url"
      contain
      @click="close()"
      ><template v-slot:placeholder>
        <v-row class="fill-height ma-0" align="center" justify="center">
          <v-progress-circular
            indeterminate
            color="grey lighten-5"
          ></v-progress-circular>
        </v-row>
      </template>
    </v-img>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  computed: {
    ...mapState("fullScreenPicture", ["url"]),
  },
  methods: {
    close() {
      this.$store.commit("fullScreenPicture/setUrl", null);
    },
  },
};
</script>
<style>
.fullScreenPicture {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 2;
  width: 100vw !important;
  height: 100vh !important;
  animation: fadein 0.2s;
  transform-origin: 50% 50%;
  background-color: transparent !important;
  backdrop-filter: blur(6px);
}
@keyframes fadein {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
</style>